(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 29192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorFooter/HomePayVisitorFooter.js + 17 modules
var HomePayVisitorFooter = __webpack_require__(17478);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Layout/Footer/Footer.tsx





var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var ABOUTUS_URL = publicRuntimeConfig.ABOUTUS_URL,
    HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
    HOUSEHOLD_URL = publicRuntimeConfig.HOUSEHOLD_URL,
    NPR_URL = publicRuntimeConfig.NPR_URL,
    NTG_URL = publicRuntimeConfig.NTG_URL,
    RESOURCE_CENTER_CHILDCARE_URL = publicRuntimeConfig.RESOURCE_CENTER_CHILDCARE_URL,
    FOR_PARTNERS_URL = publicRuntimeConfig.FOR_PARTNERS_URL,
    PRIVACY_POLICY_URL = publicRuntimeConfig.PRIVACY_POLICY_URL,
    SITEMAP_URL = publicRuntimeConfig.SITEMAP_URL,
    SNC_URL = publicRuntimeConfig.SNC_URL,
    STATETAX_URL = publicRuntimeConfig.STATETAX_URL,
    TOS_URL = publicRuntimeConfig.TOS_URL;

var Footer = function Footer(_ref2) {
  var featured = _ref2.featured,
      _ref2$isMobile = _ref2.isMobile,
      isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomePayVisitorFooter/* default */.Z, {
    isMobile: isMobile,
    featured: featured,
    footNotes: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "**Happiness Guarantee: We proudly stand behind the quality of our service. If you are unhappy with our service for any reason within the first 6 months after we activate your account, call our dedicated team of consultants at 1-888-273-3356 within that 6-month time period. We will then reimburse all HomePay fees paid by you prior to your call. A reimbursement may only be requested once under this guarantee, and cannot be used again if you reenroll. Reimbursement does not include fees for non-sufficient funds, credit card processing fees and payroll reversal fees. This Happiness Guarantee is valid for clients who pay HomePay directly for quarterly or monthly service fees. It is not valid for corporate clients including Care@Work and senior care agency clients."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "***Service Accuracy Guarantee: We guarantee (i) that your tax returns will be filed accurately and on time, and (ii) that your tax remittances will be paid on schedule if, in each of the foregoing cases, we receive your complete and accurate information by the end of the calendar quarter. If you incur monetary penalties from tax regulators due to our fault, and we are not successful in getting those amounts waived, we will at our discretion either pay those penalties on your behalf, or reimburse you for those amounts, in each case, excluding any other liability or the underlying tax obligation itself. We will not be at fault if we cannot collect the necessary amounts from your bank account or credit card on the day we request it. Please reference the Service Accuracy Guarantee by telephone at 888-273-3356 with respect to an error made during the period such recipient(s) were HomePay customers."
    })],
    linkColumns: [{
      groupTitle: 'About Homepay',
      links: [{
        label: 'About us',
        address: ABOUTUS_URL
      }, {
        label: 'Site map',
        address: SITEMAP_URL
      }, {
        label: 'Terms of use',
        address: TOS_URL
      }, {
        label: 'Privacy policy',
        address: PRIVACY_POLICY_URL
      }]
    }, {
      groupTitle: 'Tax & payroll service',
      links: [{
        label: 'Service & pricing',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.productAndPricing.relativeURL */.ZY.productAndPricing.relativeURL)
      }, {
        label: 'Nanny',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.productAndPricing.relativeURL */.ZY.productAndPricing.relativeURL)
      }, {
        label: 'Senior care',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.seniorCare.relativeURL */.ZY.seniorCare.relativeURL)
      }, {
        label: 'Household workers',
        address: HOUSEHOLD_URL
      }, {
        label: 'For partners',
        address: FOR_PARTNERS_URL
      }, {
        label: 'For caregivers',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.caregiver.relativeURL */.ZY.caregiver.relativeURL)
      }, {
        label: 'ProPortal',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.proPortal.relativeURL */.ZY.proPortal.relativeURL)
      }]
    }, {
      groupTitle: 'Useful resources',
      links: [{
        label: 'Resource center',
        address: RESOURCE_CENTER_CHILDCARE_URL
      }, {
        label: 'Nanny tax guide',
        address: NTG_URL
      }, {
        label: 'Sample nanny contract',
        address: SNC_URL
      }, {
        label: 'Nanny pay rates',
        address: NPR_URL
      }, {
        label: 'State tax & payroll laws',
        address: STATETAX_URL
      }, {
        label: 'Nanny tax calculator',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.nannyTaxCalculator.relativeURL */.ZY.nannyTaxCalculator.relativeURL)
      }]
    }, {
      groupTitle: 'Contact us',
      links: [{
        label: "Call toll-free ".concat(constants/* PHONE_LABEL */.el),
        address: constants/* PHONE_LINK */.v
      }, {
        label: 'Mon - Thurs: 8am - 6pm CT',
        address: '#'
      }, {
        label: 'Fri: 8am - 5pm CT',
        address: '#'
      }, {
        label: "Email: ".concat(constants/* HP_EMAIL */.V),
        address: "mailto:".concat(constants/* HP_EMAIL */.V)
      }]
    }]
  });
};

/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ./src/components/Layout/Footer/index.ts


/***/ }),

/***/ 93218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Layout_HomepageFooter; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/components/Layout/Footer/index.ts + 1 modules
var Footer = __webpack_require__(29192);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/HomepageFooter.tsx







var HomepageFooter = function HomepageFooter() {
  var _theme$palette$care, _theme$palette$care2;

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
    featured: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[600],
          fontWeight: 400
        },
        href: "https://www.forbes.com/sites/nextavenue/2019/06/12/ways-to-vet-a-caregiver-or-caregiving-agency/#546bd23a8a7f",
        target: "_blank",
        underline: "none",
        children: "Ways To Vet A Caregiver Or Caregiving Agency"
      }), ' ', "From Forbes. \xA9 2019 Forbes. All rights reserved. Used under license."]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.grey[600],
          fontWeight: 400
        },
        href: "https://www.huffpost.com/entry/senior-care_b_11057736",
        target: "_blank",
        underline: "none",
        children: "Senior Care: Hope for the Best, Prepare for the Worst"
      }), ' ', "From HuffPost. \xA9 2016 Oath Inc.. All rights reserved. Used under license."]
    })],
    isMobile: isMobile
  });
};

/* harmony default export */ var Layout_HomepageFooter = (HomepageFooter);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts


/***/ }),

/***/ 83398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ _404; }
});

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreVisitorGlobalHeader/CoreVisitorGlobalHeader.js + 42 modules
var CoreVisitorGlobalHeader = __webpack_require__(14342);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@care/react-pages/dist/Error404/Error404.js + 2 modules
var Error404 = __webpack_require__(56975);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts + 1 modules
var Layout = __webpack_require__(93218);
// EXTERNAL MODULE: ./src/components/contexts/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(45410);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/404.tsx










var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL;

var Custom404 = function Custom404() {
  var _flags$CLIENT_FEATURE, _flags$CLIENT_FEATURE2;

  var _useFeatureFlags = (0,FeatureFlagsContext/* useFeatureFlags */.g)(),
      flags = _useFeatureFlags.flags;

  var logoUrl = (_flags$CLIENT_FEATURE = (_flags$CLIENT_FEATURE2 = flags[constants/* CLIENT_FEATURE_FLAGS.TTP_ASSET_URL */.Pq.TTP_ASSET_URL]) === null || _flags$CLIENT_FEATURE2 === void 0 ? void 0 : _flags$CLIENT_FEATURE2.value) !== null && _flags$CLIENT_FEATURE !== void 0 ? _flags$CLIENT_FEATURE : "".concat(CORE_BASE_URL, "/s/d/ttp/care-logo.svg");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    container: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CoreVisitorGlobalHeader/* default */.Z, {
        altLogoUrl: logoUrl
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      sx: {
        paddingX: 9,
        paddingY: 3
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Error404/* default */.Z, {
        prev: "/"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* HomepageFooter */.w, {})
    })]
  });
};

/* harmony default export */ var _404 = (Custom404);
;// CONCATENATED MODULE: ./src/pages/404.tsx


/***/ }),

/***/ 18546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lh": function() { return /* binding */ useMobileQuery; },
/* harmony export */   "PG": function() { return /* binding */ useGetHeaderLeftSideLinks; },
/* harmony export */   "ZO": function() { return /* binding */ useMediaSameAndDown; }
/* harmony export */ });
/* unused harmony export useMediaSameAndUp */
/* harmony import */ var _care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5136);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18459);




var useMobileQuery = function useMobileQuery() {
  return (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.breakpoints.down */ .rS.breakpoints.down('md'));
};
var useMediaSameAndDown = function useMediaSameAndDown(breakpoint) {
  return (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.breakpoints.down */ .rS.breakpoints.down(breakpoint));
};
var useMediaSameAndUp = function useMediaSameAndUp(breakpoint) {
  return useMuiMediaQuery(theme.breakpoints.up(breakpoint));
};
var useGetHeaderLeftSideLinks = function useGetHeaderLeftSideLinks(isMobile, publicRuntimeConfig, leftLinks) {
  var HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
      RESOURCE_CENTER_URL = publicRuntimeConfig.RESOURCE_CENTER_URL,
      FOR_PARTNERS_URL = publicRuntimeConfig.FOR_PARTNERS_URL;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      leftSideLinks = _useState[0],
      setLeftSideLinks = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setLeftSideLinks(leftLinks !== null && leftLinks !== void 0 ? leftLinks : [{
      text: 'Home',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.mainVHP.relativeURL */ .ZY.mainVHP.relativeURL),
      type: 'link',
      isVisible: isMobile
    }, {
      text: 'Service & Pricing',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.productAndPricing.relativeURL */ .ZY.productAndPricing.relativeURL),
      type: 'link'
    }, {
      text: 'Resource Center',
      href: RESOURCE_CENTER_URL,
      type: 'link'
    }, {
      text: 'For Caregivers',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.caregiver.relativeURL */ .ZY.caregiver.relativeURL),
      type: 'link'
    }, {
      text: 'For Partners',
      href: FOR_PARTNERS_URL,
      type: 'link'
    }, {
      text: 'ProPortal',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.proPortal.relativeURL */ .ZY.proPortal.relativeURL),
      type: 'link'
    }]);
  }, [leftLinks, isMobile, HOMEPAY_URL, RESOURCE_CENTER_URL, FOR_PARTNERS_URL]);
  return leftSideLinks;
};

/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(83398);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4690,6537,611,2284,5114,2046,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);